import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import Aos from 'aos';

const WhyUs = () => {
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <section 
      className='w-full min-h-screen bg-[#F2F2F2] px-6 py-16 md:px-16 lg:px-24 xl:px-32 font-sans flex flex-col justify-center items-center'
      data-aos="fade-up" 
      data-aos-offset="50"
    >
      {/* Maximum Layout Content Bounding Box */}
      <div className='w-full max-w-[1200px] flex flex-col gap-12 md:gap-20'>
        
        {/* Minimalist Left-Aligned Title Header */}
        <div className='max-w-[800px] text-left'>
          <h2 className='text-[#022447] text-4xl md:text-5xl lg:text-[56px] font-bold leading-[1.15] tracking-tight'>
            Why choose <span className='text-[#6CA40B]'>Andurar Cloud Service?</span>
          </h2>
        </div>

        {/* Multi-Device Columns Configuration:
          1 Column (Mobile) -> 2 Columns (Tablet) -> 4 Columns (Laptop/Desktop/2nd-Gen Displays)
        */}
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 xl:gap-12 w-full items-start'>
          
          {/* Feature Block 1 */}
          <div className='flex flex-col gap-3 text-left' data-aos="fade-up" data-aos-delay="0">
            <h3 className='font-bold text-[#022447] text-xl md:text-2xl lg:text-[26px] tracking-tight leading-snug'>
              Proven Expertise
            </h3>
            <p className='text-[#4A5568] text-sm md:text-base leading-relaxed font-normal'>
              With years of experience in cloud technology, we provide tailored solutions to fit your specific business needs.
            </p>
          </div>

          {/* Feature Block 2 */}
          <div className='flex flex-col gap-3 text-left' data-aos="fade-up" data-aos-delay="150">
            <h3 className='font-bold text-[#022447] text-xl md:text-2xl lg:text-[26px] tracking-tight leading-snug'>
              24/7 Support
            </h3>
            <p className='text-[#4A5568] text-sm md:text-base leading-relaxed font-normal'>
              Our dedicated team of experts is available around the clock to ensure your infrastructure runs smoothly.
            </p>
          </div>

          {/* Feature Block 3 */}
          <div className='flex flex-col gap-3 text-left' data-aos="fade-up" data-aos-delay="300">
            <h3 className='font-bold text-[#022447] text-xl md:text-2xl lg:text-[26px] tracking-tight leading-snug'>
              Flexible Pricing
            </h3>
            <p className='text-[#4A5568] text-sm md:text-base leading-relaxed font-normal'>
              Choose from various pricing plans that offer flexibility and scalability, ensuring you get the most value from your investment.
            </p>
          </div>

          {/* Feature Block 4 */}
          <div className='flex flex-col gap-3 text-left' data-aos="fade-up" data-aos-delay="450">
            <h3 className='font-bold text-[#022447] text-xl md:text-2xl lg:text-[26px] tracking-tight leading-snug'>
              Enterprise-Grade Security
            </h3>
            <p className='text-[#4A5568] text-sm md:text-base leading-relaxed font-normal'>
              Your data is protected by advanced security measures, ensuring that it stays safe from unauthorized access.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyUs;